// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pip-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4f5f7;
  padding: 24px;
  box-sizing: border-box;
}

.pip-card {
  width: 100%;
  max-width: 460px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  padding: 32px;
  box-sizing: border-box;
}

.pip-center {
  text-align: center;
}

.pip-title {
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 4px;
  color: #1a1a2e;
}

.pip-muted {
  color: #6b7280;
  margin: 0 0 16px;
  font-size: 14px;
}

.pip-amount-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: 16px 0;
  border-top: 1px solid #eef0f3;
  border-bottom: 1px solid #eef0f3;
  margin: 16px 0 24px;
}

.pip-amount {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a2e;
}

.pip-pay-button {
  width: 100%;
  padding: 14px 16px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #635bff 0%, #4b45c6 100%);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.pip-pay-button:hover {
  opacity: 0.92;
}

.pip-pay-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Second (and later) pay buttons get spacing above them. */
.pip-pay-button + .pip-pay-button {
  margin-top: 10px;
}

.pip-pay-button-paypal {
  background: linear-gradient(135deg, #ffc439 0%, #f5b800 100%);
  color: #172b4d;
}

.pip-secure-note {
  text-align: center;
  color: #9ca3af;
  font-size: 12px;
  margin-top: 14px;
}

.pip-banner {
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 14px;
  margin-bottom: 16px;
  line-height: 1.4;
}

.pip-banner-success {
  background: #e7f6ec;
  color: #1b7a3d;
}

.pip-banner-warn {
  background: #fff6e5;
  color: #9a6700;
}

.pip-banner-error {
  background: #fdecec;
  color: #b42318;
}

.pip-check {
  width: 56px;
  height: 56px;
  line-height: 56px;
  border-radius: 50%;
  background: #e7f6ec;
  color: #1b7a3d;
  font-size: 30px;
  font-weight: 700;
  margin: 0 auto 16px;
}

.pip-link {
  display: inline-block;
  margin-top: 18px;
  color: #4b45c6;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
}

.pip-link:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/payments/PublicInvoicePayment.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".pip-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f4f5f7;\n  padding: 24px;\n  box-sizing: border-box;\n}\n\n.pip-card {\n  width: 100%;\n  max-width: 460px;\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);\n  padding: 32px;\n  box-sizing: border-box;\n}\n\n.pip-center {\n  text-align: center;\n}\n\n.pip-title {\n  font-size: 22px;\n  font-weight: 700;\n  margin: 0 0 4px;\n  color: #1a1a2e;\n}\n\n.pip-muted {\n  color: #6b7280;\n  margin: 0 0 16px;\n  font-size: 14px;\n}\n\n.pip-amount-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  padding: 16px 0;\n  border-top: 1px solid #eef0f3;\n  border-bottom: 1px solid #eef0f3;\n  margin: 16px 0 24px;\n}\n\n.pip-amount {\n  font-size: 28px;\n  font-weight: 700;\n  color: #1a1a2e;\n}\n\n.pip-pay-button {\n  width: 100%;\n  padding: 14px 16px;\n  border: none;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #635bff 0%, #4b45c6 100%);\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n}\n\n.pip-pay-button:hover {\n  opacity: 0.92;\n}\n\n.pip-pay-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Second (and later) pay buttons get spacing above them. */\n.pip-pay-button + .pip-pay-button {\n  margin-top: 10px;\n}\n\n.pip-pay-button-paypal {\n  background: linear-gradient(135deg, #ffc439 0%, #f5b800 100%);\n  color: #172b4d;\n}\n\n.pip-secure-note {\n  text-align: center;\n  color: #9ca3af;\n  font-size: 12px;\n  margin-top: 14px;\n}\n\n.pip-banner {\n  border-radius: 8px;\n  padding: 12px 14px;\n  font-size: 14px;\n  margin-bottom: 16px;\n  line-height: 1.4;\n}\n\n.pip-banner-success {\n  background: #e7f6ec;\n  color: #1b7a3d;\n}\n\n.pip-banner-warn {\n  background: #fff6e5;\n  color: #9a6700;\n}\n\n.pip-banner-error {\n  background: #fdecec;\n  color: #b42318;\n}\n\n.pip-check {\n  width: 56px;\n  height: 56px;\n  line-height: 56px;\n  border-radius: 50%;\n  background: #e7f6ec;\n  color: #1b7a3d;\n  font-size: 30px;\n  font-weight: 700;\n  margin: 0 auto 16px;\n}\n\n.pip-link {\n  display: inline-block;\n  margin-top: 18px;\n  color: #4b45c6;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.pip-link:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
